import { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import Inicio from './pages/Inicio';
import Gildas from './pages/Gildas';
import Bebidas from './pages/Bebidas';
import Historia from './pages/Historia';
import Visitanos from './pages/Visitanos';
import Galeria from './pages/Galeria';
import Tortilla from './pages/Tortilla';
import Pedido from './pages/Pedido';
import Dossier from './pages/Dossier';
import AvisoLegal from './pages/AvisoLegal';
import PoliticaPrivacidad from './pages/PoliticaPrivacidad';
import PoliticaCookies from './pages/PoliticaCookies';
import CookieConsent from './components/CookieConsent';

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      // Defer to allow content to render
      const id = hash.slice(1);
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        else window.scrollTo({ top: 0, behavior: 'auto' });
      }, 50);
    } else {
      window.scrollTo({ top: 0, behavior: 'auto' });
    }
  }, [pathname, hash]);
  return null;
}

function RevealOnScroll() {
  const { pathname } = useLocation();
  useEffect(() => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const els = document.querySelectorAll('.rv');
    if (reduce) {
      els.forEach(el => el.classList.add('on'));
      return;
    }
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('on'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.1 });
    els.forEach(el => obs.observe(el));
    return () => obs.disconnect();
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <ScrollToTop />
      <RevealOnScroll />
      <Navbar />
      <main>
        <div className="page">
          <Routes>
            <Route path="/" element={<Inicio />} />
            <Route path="/gildas" element={<Gildas />} />
            <Route path="/tortilla" element={<Tortilla />} />
            <Route path="/bebidas" element={<Bebidas />} />
            <Route path="/historia" element={<Historia />} />
            <Route path="/visitanos" element={<Visitanos />} />
            <Route path="/galeria" element={<Galeria />} />
            <Route path="/pedido" element={<Pedido />} />
            <Route path="/dossier" element={<Dossier />} />
            <Route path="/aviso-legal" element={<AvisoLegal />} />
            <Route path="/politica-privacidad" element={<PoliticaPrivacidad />} />
            <Route path="/politica-cookies" element={<PoliticaCookies />} />
            <Route path="*" element={<Inicio />} />
          </Routes>
        </div>
      </main>
      <Footer />
      <WhatsAppButton />
      <CookieConsent />
    </div>
  );
}

export default App;
